export enum Roles{
    "Admin"="Admin",
     "Student"="Student", 
     "Teacher"="Teacher",
     "superAdmin"="superAdmin"
}